import { render } from "./ChatMessages.vue?vue&type=template&id=6f44b308&scoped=true&ts=true"
import script from "./ChatMessages.vue?vue&type=script&lang=ts"
export * from "./ChatMessages.vue?vue&type=script&lang=ts"

import "./ChatMessages.vue?vue&type=style&index=0&id=6f44b308&lang=scss&scoped=true"
import "./ChatMessages.vue?vue&type=style&index=1&id=6f44b308&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f44b308"]])

export default __exports__